import BoletoService from 'services/boleto'
import FileSaver from 'file-saver'
import { createAction } from 'redux-act'
import { message } from 'antd'

const REDUCER = 'charges'
const NS = `@@${REDUCER}/`

export const blockEmit = createAction(`${NS}BLOCK_EMIT`)
export const chargeDetailState = createAction(`${NS}CHARGE_DETAIL_STATE`)
export const loadBoletos = createAction(`${NS}LOAD_BOLETOS`)
export const loadCustomers = createAction(`${NS}LOAD_CUSTOMERS`)
export const setCustomerEditFormVisible = createAction(`${NS}SET_CUSTOMER_FORM_VISIBLE`)
export const setCustomerWaitingDone = createAction(`${NS}SET_CUSTOMER_WAITING_DONE`)
export const setEditingCustomer = createAction(`${NS}SET_EDITING_CUSTOMER`)
export const setEmitLoading = createAction(`${NS}SET_EMIT_LOADING`)
export const setBoletoDetailsData = createAction(`${NS}SET_BOLETO_DETAILS_DATA`)

// ----------------------------------------BOLETOS-----------------------------------------------

export const openBoletoDetail = (chargeId) => {
  return async (dispatch) => {
    try {
      const { data } = await BoletoService.getBoleto(chargeId)
      await dispatch(setBoletoDetailsData(data))
      await dispatch(chargeDetailState(true))
    } catch (error) {
      message.error('Não foi possível carregar os dados do boleto.')
    }
  }
}

export const closeBoletoDetail = () => {
  return async dispatch => {
    await dispatch(setBoletoDetailsData({}))
    await dispatch(setDetailState(false))
  }
}

export const setDetailState = (visible) => (dispatch) => {
  dispatch(chargeDetailState(visible))
}

export const initialBoletoLoader = (params, hidefn) => async (dispatch, getState) => {
  try {
    const state = getState()
    const hide = hidefn || message.loading('Carregando dados...')
    if (!state.login.jwt) {
      return setTimeout(() => {
        dispatch(initialBoletoLoader({ params }, hide))
      }, 500)
    }

    const { data } = await BoletoService.list(params)
    await dispatch(loadBoletos(data.boletos))
  } catch (error) {
    console.error(error)
    message.error('Erro ao carregar dados.')
  }
}

export const downloadBoleto = async chargeId => {
  try {
    const hide = message.loading('O download iniciará em instantes.')
    const response = await BoletoService.download(chargeId)
    FileSaver.saveAs(response.data, `boleto-${chargeId}.pdf`)
    hide()
    message.success('Download realizado com sucesso.')
  } catch (error) {
    message.error('Falha ao realizar o download do boleto.')
  }
}

export const reSendEmail = async params => {
  try {
    const response = await BoletoService.email(params)

    if (response.status === 200) {
      message.success('E-mail enviado com sucesso.')
    }
  } catch (error) {
    let errorMessage = 'Erro ao enviar e-mail.'
    if (
      error.response &&
      error.response.data &&
      error.response.data.errors.errorMessage &&
      typeof error.response.data.errors.errorMessage.content === 'string'
    ) {
      errorMessage = error.response.data.errors.errorMessage.content
    }
    message.error(errorMessage)
  }
}

// ----------------------------------------REDUCERS-----------------------------------------------

const reducer = (state, action) => {
  if (state === undefined) {
    return {
      boletoDetailsData: {},
      boletoPrintData: null,
      boletos: [],
      cities: ['Selecione a UF'],
      customers: null,
      detail: false,
      editingUser: {},
      emitIsBlocked: false,
      emitLoading: false,
      isCustomerFormVisible: false,
      setCustomerWaitingDone: false,
      submitCustomerForm: false
    }
  }

  switch (action.type) {
    case loadBoletos.toString():
      return {
        ...state,
        boletos: action.payload
      }

    case loadCustomers.toString():
      return {
        ...state,
        customers: action.payload
      }

    case chargeDetailState.toString():
      return {
        ...state,
        detail: action.payload
      }

    case blockEmit.toString():
      return {
        ...state,
        emitIsBlocked: action.payload
      }

    case setEmitLoading.toString():
      return {
        ...state,
        emitLoading: action.payload
      }

    case setCustomerEditFormVisible.toString():
      return {
        ...state,
        isCustomerFormVisible: action.payload
      }

    case setEditingCustomer.toString():
      return {
        ...state,
        editingUser: action.payload
      }

    case setCustomerWaitingDone.toString():
      return {
        ...state,
        setCustomerWaitingDone: action.payload
      }

    case setBoletoDetailsData.toString():
      return {
        ...state,
        boletoDetailsData: action.payload
      }

    default:
      return state
  }
}

export default reducer
